import { Typography } from "@material-ui/core";
import BlockBox from "components/generics/BlockBox";
import ReactMarkdown from "components/generics/ReactMarkdown";
import { createUseStyles } from "react-jss";
import { PRIMARY_BACKGROUND } from "utils/data";

const useStyles = createUseStyles({
    messageSection: {
    },
    messageBody: {
        display: "flex",
        padding: "50px 0",
    },
    messageImage: {
        width: "50%",
        paddingRight: "30px",
        "& img": {
            width: "100%",
            height: "auto",
            maxWidth: "590px",
        }
    },
    message: {
        width: "50%",
    },
    "@media screen and (max-width:760px)": {
        messageSection: {
            padding: "10px",
        },
        messageBody: {
            flexDirection: "column",
        },
        messageImage: {
            width: "100%",
            margin: "0 auto",
            paddingRight: 0,
            "& img": {
                width: "100%",
                height: "auto",
                maxWidth: "590px",
            }
        },
        message: {
            width: "100%",
            paddingTop: "30px",
        },
    }
})

function FoundersMessage({ data }) {
    const classes = useStyles()

    return (
        <>
            <BlockBox
                backgroundColor={PRIMARY_BACKGROUND}
            >
                <div className={classes.messageSection}>
                    {/* <Typography
                        variant="h2"
                        className="center"
                    >
                        {data.title}
                    </Typography> */}

                    <div className={classes.messageBody}>
                        <div className={classes.messageImage}>
                            <img
                                src={data.image}
                                alt={data.name}
                            />
                        </div>
                        <div className={classes.message}>
                            <div>
                                <div
                                    className="flex-row"
                                >
                                    <Typography
                                        variant="h2"
                                        color="primary"
                                    >
                                        {data.name.split(' ')[0]}
                                    </Typography>&nbsp;
                                    <Typography
                                        variant="h2"
                                    >
                                        {data.name.split(' ')[1]}
                                    </Typography>
                                </div>
                                {
                                    data.designation_list.map((designation, index) => (
                                        <div
                                            key={index}
                                        >
                                            <Typography
                                                variant="body2"
                                            >
                                                {designation.title}
                                            </Typography>
                                        </div>
                                    ))
                                }
                            </div>
                            <ReactMarkdown
                                source={data.message}
                            />
                        </div>
                    </div>
                </div>
            </BlockBox>

        </>
    )
}

export default FoundersMessage;